import { User } from 'models'
import * as _ from 'lodash'
import { LocalStorage } from 'core/web-storage'
import { CurrentUserDecorator } from 'decorators'

export class CurrentUser extends User {

  protected decorator: CurrentUserDecorator
  private _currentRole:string = null

  hasRole(role:string):boolean {
    return this.currentRole == role
  }

  hasAnyOfRoles(roles:string[]):boolean {
    return _.flatten(roles).indexOf(this.currentRole) >= 0
  }

  get currentRole():string {
    if (this._currentRole) {
      return this._currentRole
    }
    let storedRole = localStorage.getItem('_currentRole')
    if (this.roles.indexOf(storedRole) >= 0) {
      this._currentRole = storedRole
    } else {
      this._currentRole = this.roles[0]
    }
    
    return this._currentRole
  }

  set currentRole(role:string) {
    if (this.roles.indexOf(role) >= 0) {
      this._currentRole = role
      localStorage.setItem('_currentRole', role)
    }
  }

  decorate(): CurrentUserDecorator {
    if(!this.decorator) { this.decorator = new CurrentUserDecorator(this) }
    return this.decorator
  }

  needCorrection(): boolean {
    let login = this.email.split('@')[0]
    return this.firstname == login || this.lastname == login
  }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/current-user.model.ts